import http from './cart/http.service';

export const userService = {
    login,
    logout,
    getLogueado,
    estaLogueado,
    buscar,
    traerListadoGral,
    chequearMailExiste,
    guardarCelular,
    crear,
    registrar,
    editarUsuario,
    actualizarPassUsuario,
    eliminarUsuario,
    actualizarMPCredenciales,
    actualizarMPCredencialesAdmin,
    editarUsuarioAdmin,
    resetearPasswordAdmin,
    traerResumenUsuario,
    traerMisContactos,
    guardarMisContactos
};



/**
 * `numeroCelular` solo viaja en el alta por Google, y solo en el segundo intento: cuando ese mail
 * todavia no tiene cuenta el backend contesta 428 y el front vuelve con el telefono cargado.
 */
function login(username, password, gResponse, numeroCelular) {
    var url = '/auth/authenticate';

    return http.post(url, JSON.stringify({
        username: username,
        password: password,
        response: gResponse,
        numeroCelular: numeroCelular
    }))
        .then(data => {
            localStorage.setItem('userAutopartes', JSON.stringify(data.user.token));
            return data;
        });
}

/** Carga el celular de una cuenta que no lo tenia. Devuelve el perfil ya actualizado. */
function guardarCelular(numeroCelular) {
    const url = '/api/user/celular';

    return http.post(url, JSON.stringify({numeroCelular: numeroCelular}));
}

function chequearMailExiste(email) {
    var jCodigo = {email: email};
    var url = '/auth/chequearMailExiste';
    return http.post(url, JSON.stringify(jCodigo));
}

/** Los WhatsApp adicionales que el vendedor logueado tiene cargados en su perfil. */
function traerMisContactos() {
    const url = '/api/vendedor/contactos';
    return http.get(url);
}

/**
 * Graba la lista completa: lo que no viene en el array se da de baja del lado del server.
 */
function guardarMisContactos(contactos) {
    const url = '/api/vendedor/contactos/guardar';
    return http.post(url, JSON.stringify(contactos));
}

function buscar(data) {
    const url = '/api/user/buscar';
    return http.post(url, JSON.stringify(data));
}

function getLogueado() {
    var url = "/api/user/info";
    return http.get(url);
}

function estaLogueado() {

    let user = localStorage.getItem('userAutopartes');
    if (user !== undefined) {
        return true;
    } else {
        return false;
    }
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('userAutopartes');
}

function traerListadoGral() {
    const url = '/api/user';
    return http.get(url);
}

function crear(data) {
    const url = '/api/user/crear';
    return http.post(url, JSON.stringify(data));
}

function registrar(data) {
    const url = '/auth/registrar';
    return http.post(url, JSON.stringify(data));
}

function actualizarPassUsuario(data) {
    const url = '/api/user/actualizarPass';
    return http.post(url, JSON.stringify(data));
}

function actualizarMPCredenciales(data) {
    const url = '/api/user/actualizarCrendencialesMp';
    return http.post(url, JSON.stringify(data));
}

function actualizarMPCredencialesAdmin(data) {
    const url = '/api/admin/users/actualizarCrendencialesMp';
    return http.post(url, JSON.stringify(data));
}

/**
 * Blanquea la clave de un usuario. La nueva la genera el backend y la manda al mail del usuario:
 * no vuelve en la respuesta, asi que no hay nada que mostrar en pantalla.
 */
function resetearPasswordAdmin(id) {
    const url = '/api/admin/users/resetearPassword/' + id;
    return http.post(url, JSON.stringify({id: id}));
}

/** Compras, ventas y ultimos movimientos del usuario, para las tarjetas del detalle. */
function traerResumenUsuario(id) {
    const url = '/api/admin/users/resumen/' + id;
    return http.get(url);
}

function editarUsuarioAdmin(data) {
    const url = '/api/admin/users/actualizar';
    return http.post(url, JSON.stringify(data));
}

function editarUsuario(data) {
    const url = '/api/user/actualizar';
    return http.post(url, JSON.stringify(data));
}

function eliminarUsuario(id) {
    const url = '/api/user/eliminar/' + id;
    return http.post(url, JSON.stringify({id: id}));
}